import type { UserManager } from 'oidc-client-ts';
import { RouterProvider } from 'react-router/dom';

import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import { SessionDiagnostics } from '@/app/shell/SessionDiagnostics';
import { UnhandledErrorBar } from '@/app/shell/UnhandledErrorBar';
import type { NgTopologyConfiguration } from '@/app/topology';

type AppProps = {
  topology: NgTopologyConfiguration;
  userManager: UserManager;
};

export default function App({ topology, userManager }: AppProps) {
  return (
    <AppProviders topology={topology} userManager={userManager}>
      <SessionDiagnostics />
      <RouterProvider router={router} />
      <UnhandledErrorBar />
    </AppProviders>
  );
}
